import React, { Component } from 'react';
import {
  Paper,
  IconButton,
  Collapse,
  List,
  ListItem,
  ListItemIcon,
  ListItemText
} from '@material-ui/core';
import {
  ExpandMore,
  FiberManualRecord,
  FiberManualRecordOutlined
} from '@material-ui/icons';
import i18n from '../../i18n';
import {studioBookingTimeSymbol} from '../../constants/general';

import '../../assets/stylesheets/ScheduleView.css';

class ScheduleLegend extends Component {
  constructor(props) {
    super(props);
    this.state = {
      expandView: false
    };
  }

  handleExpandClick = () => {
    this.setState(prevState => ({ expandView: !prevState.expandView }));
  };

  render() {
    const { expandView } = this.state;
    return (
      <Paper className="blockContainer">
        <div className="blockHeader">
          <h5>{i18n.t('schedule:legend')}</h5>
          <IconButton
            className={expandView ? 'expandView' : ''}
            onClick={this.handleExpandClick}
            aria-expanded={expandView}
            aria-label={i18n.t('schedule:showMore')}
          >
            <ExpandMore color="secondary" />
          </IconButton>
        </div>
        <Collapse in={expandView} timeout="auto">
          <List dense>
            <ListItem>
              <ListItemIcon>
                <FiberManualRecordOutlined color="secondary" />
              </ListItemIcon>
              <ListItemText primary={i18n.t('schedule:default')} />
            </ListItem>
            <ListItem>
              <ListItemIcon>
                <FiberManualRecord className="emailSent" />
              </ListItemIcon>
              <ListItemText primary={i18n.t('schedule:emailSent')} />
            </ListItem>
            <ListItem>
              <ListItemIcon>
                <FiberManualRecord className="emailConfirmedNoBackground" />
              </ListItemIcon>
              <ListItemText primary={i18n.t('schedule:emailConfirmed')} />
            </ListItem>
            <ListItem>
              <ListItemIcon>
                <FiberManualRecord className="canceled" />
              </ListItemIcon>
              <ListItemText primary={i18n.t('schedule:canceled')} />
            </ListItem>
            <ListItem>
              <ListItemIcon>
                <FiberManualRecord className="declined" />
              </ListItemIcon>
              <ListItemText primary={i18n.t('schedule:declined')} />
            </ListItem>
            <ListItem>
              <ListItemIcon>
                <FiberManualRecord className="unbookedFreelancer" />
              </ListItemIcon>
              <ListItemText primary={i18n.t('schedule:unbookedFreelancer')} />
            </ListItem>
            <ListItem>
              <ListItemIcon>
                <FiberManualRecord className="selected" />
              </ListItemIcon>
              <ListItemText primary={i18n.t('schedule:selected')} />
            </ListItem>
            <ListItem>
              <ListItemIcon className='bookingTimeLegend'>
                {studioBookingTimeSymbol.AM}
              </ListItemIcon>
              <ListItemText primary={i18n.t('schedule:bookingAM')} />
            </ListItem>
            <ListItem>
              <ListItemIcon className='bookingTimeLegend'>
                {studioBookingTimeSymbol.PM}
              </ListItemIcon>
              <ListItemText primary={i18n.t('schedule:bookingPM')} />
            </ListItem>
          </List>
        </Collapse>
      </Paper>
    );
  }
}

export default ScheduleLegend;
